<div>

  <div class="filter-toolbar">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="table-top">
      <ifc-filters-active-list class="layout margin-sm" [filters]="activeFilters" (filterRemoved)="activeFilterRemoved($event)"></ifc-filters-active-list>
      <div fxHide.xs class="layout padding-right-md">
        <button mat-icon-button (click)="filterDialog()" matTooltip="Filter">
          <mat-icon>filter_list</mat-icon>
        </button>
      </div>
      <div fxHide fxShow.xs>
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #actionsMenu="matMenu">
          <button mat-menu-item (click)="filterDialog()">
            <mat-icon>filter_list</mat-icon>
            <span>Filter</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <ifc-app-scroll-container [default]="true">
    <div class="table-container">

      <div class="message-box info" *ngIf="!data.bankTransactionQueryResult.totalCount" fxLayout="row" fxLayoutGap="12px"
        fxLayoutAlign="start center">
        <mat-icon class="icon">info</mat-icon>
        <span>No data found</span>
      </div>

      <table aria-label="List of bank transactions" mat-table *ngIf="data.bankTransactionQueryResult.totalCount" [dataSource]="data.bankTransactionQueryResult.values"
        matSort (matSortChange)="refresh()">
        <ng-container matColumnDef="transactionDate">
          <th mat-header-cell mat-sort-header="transactionDate" *matHeaderCellDef> Transaction date </th>
          <td mat-cell *matCellDef="let row" class="table-cell">
            {{row.transactionDate | date}} </td>
        </ng-container>

        <ng-container matColumnDef="postedDate">
          <th mat-header-cell *matHeaderCellDef> Posted date </th>
          <td mat-cell *matCellDef="let row" class="table-cell">
            {{row.postedDate | date}} </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th class="right-align" mat-header-cell arrowPosition="before"
            *matHeaderCellDef> Amount </th>
          <td mat-cell *matCellDef="let row" class="table-cell right-align">
            {{row.amount | currency:'$'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let row" class="table-cell">
            {{row.status}}
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Type </th>
          <td mat-cell *matCellDef="let row" class="table-cell">
            {{row.type}}
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef> Description </th>
          <td mat-cell *matCellDef="let row" class="table-cell">
            {{row.description}}
          </td>
        </ng-container>

        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef> Category </th>
          <td mat-cell *matCellDef="let row" class="table-cell">
            {{row.category}} </td>
        </ng-container>

        <ng-container matColumnDef="memo">
          <th mat-header-cell *matHeaderCellDef> Memo </th>
          <td mat-cell *matCellDef="let row" class="table-cell">
            {{row.memo}}
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> ID </th>
          <td mat-cell *matCellDef="let row" class="table-cell">
            {{row.id}}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true" class="table-header"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;" class="table-row"></tr>
      </table>
    </div>
  </ifc-app-scroll-container>

  <div [hidden]="!data.bankTransactionQueryResult || data.bankTransactionQueryResult.totalCount <= 10">
    <mat-paginator #paginator showFirstLastButtons [length]="data.bankTransactionQueryResult.totalCount"
      [pageSizeOptions]="[10, 20, 50]" (page)="refresh()"></mat-paginator>
  </div>

</div>
